// OrgFullPage — port of auth/org_full.html. Organization at seat capacity. org name via ?org.
import { Link, useSearchParams } from 'react-router-dom';
import AuthShell, { AuthCardHeader } from '@/components/auth/AuthShell';
import { paths } from '@/routes/paths';

export default function OrgFullPage() {
  const [params] = useSearchParams();
  const orgName = params.get('org') ?? 'Your organization';

  return (
    <AuthShell
      pageClass="pending-page recovery-page"
      cardClass="pending-card"
      left={
        <div className="auth-content recovery-content">
          <h2 className="auth-brand-topline">Seat Limit Reached</h2>
          <h1 className="name-text-img auth-brand-line">Quralyst</h1>
          <p>
            {orgName} has reached its allocated user capacity.
            <br />
            An administrator must allocate additional seats.
          </p>
        </div>
      }
      cardHeader={
        <AuthCardHeader
          title="Capacity Reached"
          right={
            <>
              Back to
              <br />
              <Link to={paths.auth.login}>Sign in</Link>
            </>
          }
        />
      }
    >
      <div className="pending-status pending-status--danger">
        <span className="pending-status-dot pending-status-dot--danger" />
        Organization at Capacity
      </div>

      <p className="pending-intro">
        <strong>{orgName}</strong> has reached its seat limit. An auto-request has been sent to your
        administrator to increase seat capacity.
      </p>

      <div className="pending-email">
        <p className="pending-email-label">Organization</p>
        <p className="pending-email-value">{orgName}</p>
      </div>

      <p className="pending-note">
        Please contact your organization administrator to add more seats to the plan.
      </p>

      <div className="auth-success-actions">
        <Link to={paths.auth.login} className="auth-button auth-return-link">
          Return to Sign In
        </Link>
      </div>
    </AuthShell>
  );
}
